export const ACCEPTED_FILE_TYPES = {
  'application/pdf': ['.pdf'],
  'application/vnd.ms-excel': ['.xls', '.xlsx'],
  'text/csv': ['.csv']
}

export const MAX_FILE_SIZE = 10 * 1024 * 1024 // 10MB 